import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 py-20 md:py-32 overflow-hidden" data-id="element-60">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-amber-glow/10 rounded-full blur-[120px] pointer-events-none" data-id="element-61" />

      <div className="max-w-2xl mx-auto relative z-10 space-y-8 text-center md:text-left" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-6" data-id="element-63">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight text-cream" data-id="element-64">
            Te despiertas.
          </h1>

          <div className="space-y-6 text-lg md:text-xl text-cream-dim font-light leading-relaxed" data-id="element-65">
            <p data-id="element-66">No sabes por qué. Solo sabes que pasó otra vez.</p>
            <p data-id="element-67">
              Y antes de que tu cuerpo termine de darse cuenta de que está en
              una cama…{' '}
              <span className="text-amber italic" data-id="element-68">
                tu mente ya abrió la puerta.
              </span>
            </p>
            <p className="pl-4 border-l-2 border-amber/30 italic text-warmgray" data-id="element-69">
              Lista mental. Conversaciones pendientes. Dinero. Trabajo. Tu
              familia. Tu salud. El futuro.
            </p>
            <p data-id="element-70">
              Y la peor parte:{' '}
              <strong className="text-cream font-medium" data-id="element-71">el reloj.</strong>
            </p>
            <p data-id="element-72">Porque cuando ves la hora, no solo ves números.</p>
            <p className="text-2xl font-heading italic text-amber-light" data-id="element-73">
              Ves una sentencia: “mañana voy a estar rota”.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 1
      }} className="pt-12 border-t border-white/5" data-id="element-74">
          <p className="text-xl md:text-2xl font-heading text-cream leading-relaxed" data-id="element-75">
            Si esto te pasa entre 3 y 5 de la mañana, no te falta disciplina.
            <br data-id="element-76" />
            <span className="text-amber" data-id="element-77">
              Te falta un protocolo para el minuto exacto donde se enciende el
              incendio.
            </span>
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-warmgray/50" data-id="element-78">
        <span className="text-xs uppercase tracking-widest" data-id="element-79">Leer más</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-warmgray/50 to-transparent" data-id="element-80" />
      </motion.div>
    </section>;
}